import { createPageLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import { NOT_FOUND_LOAD_KEY } from '@confluence/browser-metrics/entry-points/metric-keys.ts';
export const NOT_FOUND_PAGE_LOAD = createPageLoadMetric({
	key: NOT_FOUND_LOAD_KEY,
});
